<template>
  <a-table
    :size="tableSize"
    rowKey="id"
    :columns="columns"
    :data-source="followList"
    :pagination="false"
    :bordered="tableBordered"
    :scroll="{ x: 500}"
  ></a-table>
</template>

<script>
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserFollow',
  props: {
    followList: {
      type: Array,
      default: () => []
    }
  },
  mixins: [tableMixin],
  components: {
  },
  data () {
    return {
      columns:[
        {
          title: '跟进人',
          dataIndex: 'modifierName',
          align: 'center',
        },
        {
          title: '跟进时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '跟进结果',
          dataIndex: 'resultType',
          align: 'center',
        },
        {
          title: '跟进方式',
          dataIndex: 'modeType',
          align: 'center',
        },
        {
          title: '微信添加结果:',
          dataIndex: 'addWxResult',
          align: 'center',

        },
        {
          title: '下次跟进时间:',
          dataIndex: 'nextFollowTime',
          align: 'center',
        },
        {
          title: '备注:',
          dataIndex: 'remark',
          align: 'center',
        },
      ],
      list: [],
      total: null,
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {

  }
}
</script>
